import { css } from 'linaria';

export const bannerLogoWrapper = css`
  @media (--only-mobile) {
    display: flex;
    align-items: flex-end;
    order: 2;
    margin-left: auto;
  }
`;

export const bannerLogo = css`
  display: block;
  width: 144px;
  height: 100%;
  border-radius: var(--rounding-l) 0 0 var(--rounding-l);
  object-fit: cover;

  @media (--only-mobile) {
    width: 75px;
    border-radius: 0 0 var(--rounding-l) 0;
  }
`;
